export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";